export const localStorageKey = {
  auth_status: 'auth',
};
